import { INCURSION, INCURSION_DANGER, INCURSION_RINGS, INCURSION_TIERS, IRON_MINE, type IncursionRisk } from '@somnhold/content';
import { dayNodes, type CampaignState } from '@somnhold/sim';

export type LootKey = 'wood' | 'stone' | 'crystal' | 'dust' | 'iron';

const NODE_RES: Record<string, LootKey | null> = { quarry: 'stone', forest: 'wood', crystal: 'crystal', altar: 'dust', lair: 'dust', rescue: null, iron: 'iron', fort: 'dust' };

/** What a node gives today if the extraction holds to the end (before skill perks), main resource first. */
export const incursionLoot = (s: CampaignState, me: string, day: number, nodeId: number, risk: IncursionRisk = 'normal', tier: 1 | 2 | 3 = 1): [LootKey, number][] => {
  const p = s.players.find((x) => x.id === me);
  const n = dayNodes(s, day).find((x) => x.id === nodeId);
  if (!p || !n) return [];
  const done = p.incursionDay === day ? p.incursionsToday : 0;
  const ranger = s.players.some((x) => x.hero.heroClass === 'ranger' && !x.left);
  const base = (done < INCURSION.fullPerDay ? 10000 : INCURSION.reducedBp) * (n.double && ranger ? 2 : 1);
  const risky = risk === 'danger' ? Math.trunc((base * INCURSION_DANGER.rewardBp) / 10000) : base;
  const ringed = Math.trunc((risky * INCURSION_RINGS[n.ring].rewardBp) / 10000);
  const mult = tier > 1 ? Math.trunc((ringed * INCURSION_TIERS[tier as 2 | 3].rewardBp) / 10000) : ringed;
  const amount = Math.trunc((INCURSION.reward * mult) / 10000);
  const dust = Math.trunc((INCURSION.rewardDust * mult) / 10000);
  const r = NODE_RES[n.kind];
  if (r === 'dust') return [['dust', amount + dust]];
  // Iron is scarce: a mine gives a share of a normal haul.
  if (r === 'iron') return [['iron', Math.trunc((amount * IRON_MINE.rewardBp) / 10000)], ['dust', dust]];
  if (r) return [[r, amount], ['dust', dust]];
  return [['wood', amount >> 1], ['stone', amount >> 1], ['dust', dust]];
};
